export let isShipmentExemptionEnabled = false;

// Comente a linha abaixo para desativar o flag "sem frete e sem remessa impressa" no frontend.
// Mantenha em sincronia com Features/ShipmentExemptionFeature.cs do backend.
isShipmentExemptionEnabled = true;

export const isShipmentExemptionEnabledForCycle = (cycleYear?: number | null): boolean =>
  isShipmentExemptionEnabled && cycleYear != null && cycleYear >= 2027;
